<template>
  <fieldset>
    <ul class="school-calendar-list">
      <li class="field" v-bind:key="category.id" v-for="category in categories">
        <b-checkbox
          size="is-small"
          v-model="localSelectedCategories"
          :native-value="category.id"
        >{{category.title}}</b-checkbox>
      </li>
    </ul>
  </fieldset>
</template>

<script>
import Vue from 'vue'
import { Checkbox } from 'buefy'
import EventBus from '../services/eventBus'
import { mapState } from 'vuex'
Vue.use(Checkbox)

export default {
  data () {
    return {

      localSelectedCategories: []
    }
  },
  methods: {
    resetResults () {
      this.localSelectedCategories = []
    },
    updateSelectedCategories () {
      this.$store.commit('events/UPDATE_SELECTED_CATEGORIES', this.localSelectedCategories)
    }
  },
  computed: {
    ...mapState('events', ['selectedCategories', 'categories'])
  },
  watch: {
    selectedCategories(newVal) {
      if (this.localSelectedCategories.length !== newVal.length) {
        this.localSelectedCategories = newVal
      }
    },
    localSelectedCategories () {
      if (this.localSelectedCategories.length !== this.selectedCategories.length) {
        this.updateSelectedCategories()
      }
    }
  },
  mounted() {
    EventBus.$on('reset-results', this.resetResults)
  }
}
</script>
